import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const a=t("syria",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                fill="black" />
            <path
                d="M0 4.5L24 4.5V15.1667L0 15.1667L0 4.5Z"
                fill="white" />
            <path
                d="M0 4.5L24 4.5V9.83333L0 9.83333L0 4.5Z"
                fill="#CE1126" />
            <path
                d="M6.70164 14.5L8.00137 10.5L9.3011 14.5L5.89844 12.0277H10.1043M14.7016 14.5L16.0014 10.5L17.3011 14.5L13.8984 12.0277H18.1043"
                fill="#007A3D" />
        </svg>
    `),d=t("syria_rounded",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19486_135971)">
                <path
                    d="M-6 0.5L30 0.5L30 24.5L-6 24.5L-6 0.5Z"
                    fill="black" />
                <path
                    d="M-6 0.5L30 0.5V16.5L-6 16.5L-6 0.5Z"
                    fill="white" />
                <path
                    d="M-6 0.5L30 0.5V8.5L-6 8.5L-6 0.5Z"
                    fill="#CE1126" />
                <path
                    d="M4.05246 15.5L6.00206 9.5L7.95166 15.5L2.84766 11.7916H9.15646M16.0525 15.5L18.0021 9.5L19.9517 15.5L14.8477 11.7916L21.1565 11.7916"
                    fill="#007A3D" />
            </g>
            <defs>
                <clipPath id="clip0_19486_135971">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{a as Syria,d as SyriaRounded};
